/* eslint @typescript-eslint/strict-boolean-expressions: off */

import React from "react";
import styles from "gui/browse-shared/browse.module.css";
import { BrowseUsersEmpty } from "gui/browse-users/empty";
import { UserList } from "gui/entries/user-list";
import { EntriesPagination } from "gui/entries/pagination";
import { EntriesRequestFilters } from "lib/entries/types";
import { Loading } from "gui/loading/loading";
import { useUsers } from "lib/entries/hooks";

export const BrowseUsersResults: React.FC<{
  entriesRequestFilters: EntriesRequestFilters;
  setEntriesRequestFilters: (
    entriesRequestFilters: EntriesRequestFilters
  ) => void;
}> = (props) => {
  const { data, error } = useUsers(props.entriesRequestFilters);

  if (error) {
    throw error;
  }

  if (!data) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  if (data.results.length === 0) {
    return <BrowseUsersEmpty />;
  }

  return (
    <>
      <UserList entries={data.results} />
      <EntriesPagination
        page={data}
        entriesRequestFilters={props.entriesRequestFilters}
        setEntriesRequestFilters={props.setEntriesRequestFilters}
      />
    </>
  );
};
